import type { MessagingPatient } from "src-next/modules/crm-clinical/messaging";
import {
  getPersonCpfDigits,
  getPersonDisplayName,
  getPersonPhone,
} from "./ecommercePersonDisplay";

/**
 * Converte cliente cadastrado (Person) para o contrato do FluxZap.
 * Destino explícito Person/{id} — o servidor atribuiu o id no POST do lote.
 */
export function mapPersonToMessagingPatient(
  person: fhir5.Person,
): MessagingPatient {
  const cpf = getPersonCpfDigits(person);
  const personId = person.id || cpf;

  return {
    id: personId,
    fullName: getPersonDisplayName(person),
    cpf: cpf || undefined,
    phone: getPersonPhone(person) || undefined,
    birthDate: person.birthDate,
    forReference: person.id ? `Person/${person.id}` : undefined,
  };
}
